import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import PickMatchRecord from "slotworks/model/gameplay/records/pick-match-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { clearElement } from "slotworks/utils/dom-utils";
import { freespinRecordDisplay } from "./record-displays/freespin-record-display";
import { pickMatchRecordDisplay } from "./record-displays/pick-match-record-display";
import { spinRecordDisplay } from "./record-displays/spin-record-display";

export default class RecordDisplay {

    private element: HTMLDivElement;

    constructor() {
        this.draw();
    }

    public show(record: Record) {
        clearElement(this.element);

        const infoElement = document.createElement("div");
        this.element.appendChild(infoElement);

        infoElement.innerHTML = "<br>Record type: " + record.id;
        infoElement.innerHTML += "<br>Total win: " + record.cashWon.toString();

        let displayElement: HTMLElement;

        if (record instanceof FreespinRecord) {
            displayElement = freespinRecordDisplay(record);
        } else if (record instanceof SpinRecord) {
            displayElement = spinRecordDisplay(record);
        } else if (record instanceof PickMatchRecord) {
            displayElement = pickMatchRecordDisplay(record);
        } else {
            displayElement = document.createElement("div");
            displayElement.innerHTML = "No display implementation";
        }

        this.element.appendChild(displayElement);
    }

    public toggle() {
        if (this.element.parentElement) {
            canvasManager.rootNode.removeChild(this.element);
        } else {
            canvasManager.rootNode.appendChild(this.element);
        }
    }

    private draw() {
        this.element = document.createElement("div");
        this.element.id = "integrationDebugger_recordDisplay";

        this.element.style.boxSizing = "border-box";
        this.element.style.position = "fixed";
        this.element.style.top = "0";
        this.element.style.left = "20vw";
        this.element.style.zIndex = "900";
        this.element.style.width = "60vw";
        this.element.style.height = "50vh";
        this.element.style.paddingTop = "5vh";
        this.element.style.paddingLeft = "3vw";

        this.element.style.backgroundColor = "#222";
        this.element.style.border = "solid 1px white";

        this.element.style.color = "#fff";
        this.element.style.fontSize = "20px";

        canvasManager.rootNode.appendChild(this.element);
    }
}
